var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryUg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7480)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7480",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.66667H28V0H0V2.66667Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3333H28V10.6666H0V13.3333Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6666H28V6.66663H0V10.6666Z",
    fill: "#ED1623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66663H28V2.66663H0V6.66663Z",
    fill: "#FEE044"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V17.3334H0V20Z",
    fill: "#ED1623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.3334H28V13.3334H0V17.3334Z",
    fill: "#FEE044"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 14.6667C16.5772 14.6667 18.6666 12.5774 18.6666 10C18.6666 7.42271 16.5772 5.33337 13.9999 5.33337C11.4226 5.33337 9.33325 7.42271 9.33325 10C9.33325 12.5774 11.4226 14.6667 13.9999 14.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9024 7.56903C12.7722 7.43885 12.7722 7.2278 12.9024 7.09762L13.3142 6.68577C13.3269 6.67305 13.3383 6.65967 13.3492 6.64534C13.3842 6.5992 13.4735 6.48653 13.5778 6.39167C13.7545 6.23096 14.2579 6.21409 14.4323 6.37732C14.4797 6.42163 14.5229 6.47097 14.5591 6.51618C14.631 6.60615 14.6353 6.72929 14.5838 6.83231L14.0352 7.92961C14.012 7.97589 14 8.02693 14 8.07868V8.46065C14 8.5869 14.0713 8.70232 14.1843 8.75879L15.285 9.30913C15.317 9.32516 15.3462 9.34624 15.3716 9.37157L16.4968 10.4968C16.5982 10.5982 16.6234 10.7532 16.5592 10.8815L16.2068 11.5863C16.1051 11.7898 15.8339 11.8339 15.673 11.673L15.569 11.569C15.4389 11.4389 15.2278 11.4389 15.0976 11.569L14.7643 11.9024C14.7018 11.9649 14.6667 12.0497 14.6667 12.1381V12.5286C14.6667 12.617 14.7018 12.7018 14.7643 12.7643C14.9743 12.9743 14.8256 13.3333 14.5286 13.3333H14.1381C13.8411 13.3333 13.6924 12.9743 13.9024 12.7643C13.9649 12.7018 14 12.617 14 12.5286V12.3333C14 12.1492 13.8508 12 13.6667 12H13.4714C13.383 12 13.2982 12.0351 13.2357 12.0976L12.9024 12.431C12.7722 12.5611 12.5611 12.5611 12.431 12.431L12.2357 12.2357C12.1055 12.1055 12.1055 11.8945 12.2357 11.7643L12.569 11.431C12.6315 11.3684 12.7163 11.3333 12.8047 11.3333H13.1953C13.4922 11.3333 13.641 10.9743 13.431 10.7643L12.2357 9.56903C12.1055 9.43885 12.1055 9.2278 12.2357 9.09762L13.0976 8.23569C13.2278 8.10552 13.2278 7.89446 13.0976 7.76429L12.9024 7.56903Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7480"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryUg);
export default __webpack_public_path__ + "static/media/Country=UG.cee3ffb35cb22189c97ed1f0d8a810dd.svg";
export { ForwardRef as ReactComponent };